module.exports = __webpack_public_path__ + "img/arrow_rjmt-01.34397aed.svg";